import { Box, styled, InputBase, IconButton } from "@mui/material";
import Button from "components/ui/Button";
import EditCatagoryModal from "components/ui/EditCatagoryModal/EditCatagoryModal";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import { useEditCatagory } from "hooks/useEditCatagory";
import apiClient from "lib/api-client";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";

import { handleSuccessNavigate, sendDataForEditCatagory } from "utils/editCatagoryHelper";
import { useDispatch, useSelector } from "react-redux";
import { clearEditCategory } from "store/cartSlice";

const CancelButton = styled(Button)(({}) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  borderRadius: "5px",
  color: "#E77B7B",
  border: "1px solid #E77B7B",
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#E77B7B",
    color: "black",
  },
}));

const StyledButton = styled(Button)(({ bgcolor, variant, disabled }) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  width: `${variant === "Next" ? "100px" : "auto"}`,
  borderRadius: "5px",
  color: `${variant === "Next" ? "#50C878" : "#ffffff"}`,
  border: `1px solid ${variant === "Next" ? "#50C878" : "#ffffff"}`,
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: `${variant === "Next" ? "#50C878" : "transparent"}`,
    color: `${variant === "Next" ? "black" : "#ffffff"}`,
  },
  "&.Mui-disabled": {
    backgroundColor: "#000000",
    color: "#8B8B8B",
    border: "1px solid #8B8B8B",
  },
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
  marginLeft: 0,
  width: "100%",
  boxShadow: "inset 0px 4px 20px 0px #00000040",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "black",
  height: "40px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    transition: theme.transitions.create("width"),

    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

const isCatagoryEdit = (isEditCatagoryData) => {
  return isEditCatagoryData && isEditCatagoryData.length > 0 ? false : true;
};

const EditCatagoryHeader = () => {
  const [open, setOpen] = useState(false);
  const [restricModalOpen, setRestricModalOpen] = useState(false);
  const { setSearch, search } = useContext(SortContext);
  const location = useLocation();
  const navigate = useNavigate();
  let [state, setState] = useState({});
  const [tempSearch, setTempSearch] = useState("");

  const [isEditDisabled, setIsEditDisabled] = useState(isCatagoryEdit(JSON.parse(sessionStorage.getItem(state?.updateCatagory)) || []));
  const { isEditCatagoryData, openEditCatagoryModal, setOpenEditCatagoryModal } = useGlobalContext();
  const { mutate: updateCatagoryFun } = useEditCatagory({ onCompleted: () => handleSuccessNavigate(location, () => setRestricModalOpen(false), navigate) });

  const dispatch = useDispatch();

  const editCategoryData = useSelector(   
    (state) => state.editCategory.data
  );
  

  // console.log("editCategoryData===>>", editCategoryData);

  // console.log("isEditDisabled====>>>>",isEditDisabled)

  const handleCancel = () => {
    setSearch("");
    let newstate = {
      name: state?.name,
      innerChnages: false,
      updateCatagory: "",
      categorySearch: location?.state?.categorySearch || "",
      subCatgeorySearch: location?.state?.subCatgeorySearch || "",
    };
    // sessionStorage.removeItem(state?.updateCatagory);
    dispatch(clearEditCategory(state?.updateCatagory));
    navigate(state.backPath, { state: newstate });
  };

  const handleSave = () => {
    if (state?.updateCatagory.trim() === "RestrictDesign") {
      setRestricModalOpen(true);
    } else {
      setOpenEditCatagoryModal(true);
    }
  };

  const handleSearch = () => {
    setSearch(tempSearch);
  };

  const handleRestrictSave = () => {
    const updateStyleNumber = sendDataForEditCatagory(state?.updateCatagory);
    const updateStyles = {
      ...updateStyleNumber,
      updateValue: true,
    };
    updateCatagoryFun(updateStyles);
  };

  const modalBtnInfo = useMemo(
    () => [
      {
        btnName: "Discard",
        bgColor: "#E77B7B",
        click: handleCancel,
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setOpen(false),
      },
    ],
    [handleCancel]
  );

  const restricModalBtnInfo = useMemo(
    () => [
      {
        btnName: "Restrict",
        bgColor: "#E77B7B",
        click: handleRestrictSave,
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setRestricModalOpen(false),
      },
    ],
    [handleRestrictSave]
  );

  useEffect(() => {
    setState(location.state);
  }, [location]);

  //checking function
  const checkCategoryEditState = useCallback(() => {
    // console.log("checking....")
    const data = JSON.parse(sessionStorage.getItem(state?.updateCatagory)) || [];
    setIsEditDisabled(isCatagoryEdit(data));
  }, [state?.updateCatagory, editCategoryData]);

  useEffect(() => {
    checkCategoryEditState();

    const handleSubcategoryUpdate = () => {
      checkCategoryEditState();
    };

    window.addEventListener("UpdateSubCategory", handleSubcategoryUpdate);

    return () => {
      window.removeEventListener("UpdateSubCategory", handleSubcategoryUpdate);
    };
  }, [checkCategoryEditState]);

  useEffect(() => {
    if (tempSearch === "") {
      setSearch("");
    }
  }, [tempSearch]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          // width: "200%",
          mr: "-15px",
          // border: "1px solid white"
        }}
      >
        <Search
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "10px",
            paddingRight: "4px",
            // border: "10px solid white",
          }}
        >
          {/* Search Icon inside Input */}
          <SearchIconPlaceHolder sx={{ color: "gray", marginRight: "8px" }} />

          <StyledInputBase
            placeholder="Search By Category or Design Number"
            onChange={(e) => setTempSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            value={tempSearch}
            inputProps={{ "aria-label": "search" }}
            sx={{ height: "40px", borderRadius: "5px" }}
          />

          <IconButton
            disableRipple
            disableFocusRipple
            sx={{
              color: "black",
              height: "34px",
              width: "69px",
              borderRadius: "5px",
              padding: "10px",
              background: "#000",
              fontFamily: "poppins",
              color: "#fff",
              fontWeight: "500",
              fontSize: "12px",
            }}
            onClick={search === "" ? handleSearch : () => setSearch("")}
          >
            {search === "" ? "Search" : "Clear"}
          </IconButton>
        </Search>

        <StyledButton onClick={handleSave} disabled={isEditDisabled} variant={"Next"}>
          Next
        </StyledButton>

        <CancelButton onClick={isEditDisabled ? () => setOpen(true) : handleCancel}>Cancel</CancelButton>

        {/* <CancelButton onClick={isCatagoryEdit(JSON.parse(sessionStorage.getItem("UpdateSubCategory")) || []) ? handleCancel : () => setOpen(true)}>Cancel</CancelButton> */}
      </Box>
      <RemoveModal open={open} setOpen={setOpen} btnInfo={modalBtnInfo} heading="Do you want to cancel the changes?" />
      <EditCatagoryModal open={openEditCatagoryModal} handleClose={() => setOpenEditCatagoryModal(false)} heading={state?.newName} updateCatagory={state?.updateCatagory} />
      <RemoveModal open={restricModalOpen} setOpen={setRestricModalOpen} btnInfo={restricModalBtnInfo} heading="Do You Want To Restrict This Designs ?" />
    </>
  );
};

export default EditCatagoryHeader;
